import './App.css';
import React from 'react';
// import * as Icon from 'react-feather';
// import { FileText } from 'react-feather';
import akm from './cover.png';
import Microlink from '@microlink/react';
// import pdfFile from './Articles Authored By Dr. A K Mehta.pdf';

function App() {
  return (
    <div className="App">
  
      {/* <header className="App-header">
        <img className="App-logo" alt="DR AK MEHTA IAS(R)" src={akm}/>
        <br/>
          <h1>Dr AK Mehta IAS(R)</h1>
        </header> */}
        <br/>
          <main className="App-maina">
       <h3> Dr. Arun Kumar Mehta, a retired Indian Administrative Service (IAS) officer of the 1988 AGMUT (Arunachal Pradesh-Goa-Mizoram and Union Territories) cadre, served as the Chief Secretary of Jammu and Kashmir (J&K) from May 31, 2021, until his retirement on November 30, 2023. His tenure as Chief Secretary was marked by significant administrative responsibilities during a transformative period for J&K, following the abrogation of Article 370 in August 2019, which led to the reorganization of the state into a Union Territory.
     </h3>
      <Microlink
  url="https://www.indiatoday.in/education-today/gk-current-affairs/story/cop24-7-points-india-paris-climate-agreement-principles-1408519-2018-12-13?utm_source=perplexity"
  size="large"
  // media="image"
  // description={false}
  lazy
/>
      {/* <Microlink
  url="https://www.dailyexcelsior.com/prime-minister-narendra-modi-conferring-the-award-for-excellence-in-public-administration-to-jk-chief-secretary-dr-arun-kumar-mehta-on-the-occasion-of-the-16th-civil-services-day-celebrations-at-vigy/"  
  lazy
/> */}

       </main>
    </div>
  );
}

export default App;